import VehicleRegistrationStatusHtml from './vehicle-registration.status.html';

export function VehicleRegistrationStatusDirective () : ng.IDirective {
  const directive : ng.IDirective = {
    controller: 'VehicleRegistrationStatusCtrl',
    restrict  : 'E',
    scope     : {
      vehicle: '='
    },
    templateUrl: VehicleRegistrationStatusHtml
  };

  return directive;
}